import React from 'react';
import {
  Box,
  Container,
  Heading,
  Text,
  VStack,
} from '@chakra-ui/react';
import { motion } from 'framer-motion';

const MotionBox = motion(Box);

/**
 * Workshop About Section
 * Displays full description and context
 */
const WorkshopAbout = ({ workshop }) => {
  if (!workshop?.description) return null;

  const { title, description } = workshop;

  return (
    <Box py={{ base: 16, md: 20 }} bg="gray.50">
      <Container maxW="container.lg">
        <MotionBox
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <VStack align="start" spacing={8} maxW="3xl">
            <VStack align="start" spacing={3}>
              <Heading as="h2" size="xl" fontWeight="900" color="gray.900">
                About This Workshop
              </Heading>
              <Box h="1" w="20" bg="purple.600" />
            </VStack>

            <Text
              fontSize="lg"
              color="gray.700"
              lineHeight="1.8"
              whiteSpace="pre-wrap"
            >
              {description}
            </Text>

            <Box bg="purple.50" p={6} borderRadius="lg" borderLeft="4px solid" borderColor="purple.600">
              <Text fontSize="md" color="gray.800" fontWeight="500">
                ✨ This is a hands-on workshop with live demonstrations and real-world examples.
              </Text>
            </Box>
          </VStack>
        </MotionBox>
      </Container>
    </Box>
  );
};

export default WorkshopAbout;
